export const sx = {
  wallet_name: {
    fontWeight: "bold",
  },
  filterWarning: {
    pt: 3,
    color: "red",
  },
  preview: {
    maxWidth: "10rem",
    margin: " 0 auto",
  },
  previewHeader: {
    display: "flex",
    margin: "auto",
    maxWidth: "40rem",
    justifyContent: "space-evenly",
  },
  previewActions: {
    display: "flex",
    justifyContent: "space-around",
  },
};
